import { Component, Input, OnInit } from '@angular/core';
import { AutoCompletionService } from '../../services/autoCompletion.service'
import { IMyDpOptions, IMyDateModel } from 'mydatepicker';

@Component({
    selector   : 'my-input',
    template: require('./input.component.html'),
    styles: [require('./input.component.scss')]
})

export class InputComponent implements OnInit{

    @Input() input: any;
    @Input('disabled') disabled: boolean;
    @Input('placeholder') placeholder: string;
    @Input('model') model: any;
    @Input('field') field: string;
    @Input('errors') errors: any;
    @Input('number') number: any;
    @Input('autocompletion') autocompletion: any = false;
    @Input('style') style: string = '';
    @Input('type') type: string = 'text';
    @Input('text') text:string = null;
    @Input('prefix') prefix:string = null;

    public autocompletionOpen        = false;
    public autocompletionResult: any = null;

    public date;
    public time;
    public error:boolean = false;

    public myDatePickerOptions: IMyDpOptions = {
        dateFormat: 'dd.mm.yyyy',
        editableDateField: false,
        showInputField: true,
        showClearDateBtn: false
    };

    constructor(private autocompletionService: AutoCompletionService) {

    }

    ngOnInit(): void {
        if (this.type=='datetime-local'){
            this.time = ('0' + (this.model[this.field].getHours())).slice(-2) + ':' + ('0' + this.model[this.field].getMinutes()).slice(-2);
            this.date = { date: {
                year: this.model[this.field].getFullYear(),
                month: this.model[this.field].getMonth() + 1,
                day: this.model[this.field].getDate()
            } };
        }
    }

    saveDate(event: IMyDateModel){
        if (!event) {

        }
        if (this.time.match(/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/)){
            this.error = false;
            let tmp = this.time.split(':');
            if (event) {
                this.model[this.field].setFullYear(event.date.year);
                this.model[this.field].setMonth(event.date.month - 1);
                this.model[this.field].setDate(event.date.day);
            } else {
                this.model[this.field].setFullYear(this.date.date.year);
                this.model[this.field].setMonth(this.date.date.month - 1);
                this.model[this.field].setDate(this.date.date.day);
            }
            this.model[this.field].setHours(tmp[0]);
            this.model[this.field].setMinutes(tmp[1]);
            this.model.modelChange(this.field);
        } else {
            this.error = true;
            this.model.state = 3;
        }
    }

    save(value) {
        if (this.autocompletion && value.length >= 1 && value.length < 42) {
            this.autocompletionOpen = true;
            this.autocompletionService.search(this.autocompletion.collection, this.autocompletion.field, value, this);
        }
        if (this.number || this.type=='number') {
            this.model[this.field] = Number(value);
        }
        else
            this.model[this.field] = value;
        this.model.modelChange(this.field);
    }

    saveAutocompletion(value){
        if (this.number || this.type=='number')
            this.model[this.field] = Number(value);
        else
            this.model[this.field] = value;
        this.model.modelChange(this.field);
        this.close();
    }

    focusout() {
        setTimeout(()=> {
            this.close();
        }, 300);
    }

    close() {
        this.autocompletionOpen   = false;
        this.autocompletionResult = null;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/components/input/input.component.ts